/**
 * Breakpoints (CLAUDE_DESIGN.md §2.5) — shared with `@xdocs/config`'s
 * Tailwind preset `screens`. CSS custom properties cannot appear inside an
 * `@media` condition in standard CSS, so component `*.module.css` files use
 * the literal px values directly (documented alongside each `@media` rule);
 * this module is the JS-side source for components that need the value at
 * runtime (`matchMedia`, resize observers) — e.g. `<DataTable>`'s
 * desktop-table / mobile-card-list switch at `md`.
 */
export const BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};
/** `md` is THE canonical mobile↔desktop switch (tables→cards, nav collapse). */
export const MOBILE_MAX_WIDTH = BREAKPOINTS.md - 1;
